import { fetchContracts, fetchContract, createContract, fetchServiceContract } from '@/services/contract/contractService'

const state = {
  contracts: [],
  contract: {},
  currentServiceContract: {},
}

const getters = {
    contracts: (state) => state.contracts,
    contract: (state) => state.contract,
    currentServiceContract: (state) => state.currentServiceContract,
}

const actions = {
  async fetchContractsByRealEstate({ commit, dispatch, rootState }, realEstateId) {
    commit('setIsLoading', true)
    commit('setContracts', [])

    const defaultParams = {
      realEstateId: realEstateId,
      size: rootState.paginate.itemsPerPage,
      page: rootState.paginate.currentPage - 1,
    }

    const params = { ...defaultParams, ...rootState.filters.filters }

    try {
      const { data } = await fetchContracts(params)
      const { result, total } = await data
      commit('setContracts', result)
      commit('setTotalPages', total)
    } catch ({ data }) {
      dispatch('showErrorMessage', data.message)
    } finally {
      commit('setIsLoading', false)
    }
  },

  async fetchContract({ commit, dispatch}, id) {
    commit('setIsLoading', true)
    try {
      const { data } = await fetchContract(id)
      commit('setContract', data)
    } catch ({ data }) {
      dispatch('showErrorMessage', data.message)
    } finally {
      commit('setIsLoading', false)
    }
  },

  async createContract({ commit}, contract) {
    commit('setIsLoading', true)
    return createContract(contract)
  },

  async fetchServiceContract({ commit, dispatch }, params) {
    commit('setIsLoading', true)
    try {

      const { data } = await fetchServiceContract({...params})
      commit('setCurrentServiceContract', data)
    } catch ({ data }) {
      dispatch('showErrorMessage', data?.message)
    } finally {
      commit('setIsLoading', false)
    }
  }

}

const mutations = {
    setContracts: (state, contracts) => {
      state.contracts = contracts
    },
    setContract: (state, contract) => {
      state.contract = contract
    },
    setCurrentServiceContract: (state, currentServiceContract) => {
      state.currentServiceContract = currentServiceContract
    },
}

export default {
    state,
    mutations,
    actions,
    getters,
}
